import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  to?: string;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  to,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 font-semibold transition-all duration-300 ease-out rounded-sm whitespace-nowrap';
  const variants = {
    primary: 'bg-engage-yellow text-engage-black hover:bg-engage-yellow-hover active:bg-engage-yellow-active hover:scale-[1.02]',
    secondary: 'bg-transparent text-engage-yellow border-2 border-engage-yellow hover:bg-engage-yellow hover:text-engage-black active:bg-engage-yellow-active hover:scale-[1.02]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClasses = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  if (to) {
    return <Link to={to} className={combinedClasses} data-id="element-76">
        {children}
      </Link>;
  }
  return <button className={combinedClasses} {...props} data-id="element-77">
      {children}
    </button>;
}